// extracted by mini-css-extract-plugin
module.exports = {"rating":"styles_rating__1S-b0","ratingImage":"styles_ratingImage__pBWgW"};